import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { resendAdminInvitation } from 'src/features/administrators/tenant/api/lib/admins';
import { adminsKeys } from 'src/features/administrators/tenant/api/query-keys/admins';

import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';

export const useResendAdminInvitation = (onSuccess?: () => void) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (adminToken: string) => {
      return resendAdminInvitation(adminToken);
    },
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({ queryKey: adminsKeys.all });
      });
      toast.success(t('common:successfullyResentInvitation'));
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
